import { useAppSelector } from 'store';

import type { DoNotCallRestrictionType } from 'infrastructure/enums';
import type { Nullable } from 'infrastructure/types';

export const useGetDoNotCallInfo = () => {
  const doNotCall = useAppSelector<{
    doNotCallRpm: boolean;
    doNotCallCcm: boolean;
    rpmRestrictionType: Nullable<DoNotCallRestrictionType>;
    ccmRestrictionType: Nullable<DoNotCallRestrictionType>;
    rpmDoNotCallReasonMessage: string;
    ccmDoNotCallReasonMessage: string;
  }>((state) => state.patient.doNotCall);

  return doNotCall;
};
